export default __webpack_public_path__ + "static/media/Santander.61a2f279.svg";